import {instructionConstraints} from '@packages/domains/instructions/data-types';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'search-instructions' as const;

const argumentZod = z.object({
  name: z
    .string()
    .trim()
    .min(1)
    .max(instructionConstraints.list.query.max)
    .optional()
    .describe('Optional filename query for narrowing instruction search.'),
  description: z
    .string()
    .trim()
    .min(1)
    .max(instructionConstraints.list.query.max)
    .optional()
    .describe('Optional description query for narrowing instruction search.'),
  markdown: z
    .string()
    .trim()
    .min(1)
    .max(instructionConstraints.list.query.max)
    .optional()
    .describe(
      'Optional markdown content query for narrowing instruction search.'
    ),
  limit: z
    .number()
    .int()
    .min(instructionConstraints.list.limit.min)
    .max(instructionConstraints.list.limit.max)
    .optional()
    .describe('Maximum number of instructions to return (default: 100).'),
  offset: z
    .number()
    .int()
    .min(instructionConstraints.list.offset.min)
    .optional()
    .describe('Number of matching instructions to skip (default: 0).'),
});

export const searchInstructionsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Search instructions',
  llmTool: {
    name: toolName,
    description:
      'Searches site-authored instruction metadata for the current site. Eligible Webflow system instructions are already listed in the prompt. Returns paths, descriptions, draft state, and pagination; it does not return markdown content.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AGENT_INSTRUCTIONS,
  permission: [{resource: 'SiteAgentInstructions', action: 'read'}],
  confirmBeforeExecuting: false,
});

export type SearchInstructionsArgumentType = z.infer<typeof argumentZod>;
